export default __webpack_public_path__ + "static/media/Dr-Vani-Vasanth-MD-FRGUHS-Aesthetic-Dermatology.102a63a0.jpg";